export function shouldShowOrdersSpinner(loading, rows = []) {
  return Boolean(loading && (!Array.isArray(rows) || rows.length === 0));
}
